export default __webpack_public_path__ + "1PIZmnc-settings.svg";